import request from '@/utils/request'

export const getTableData = params =>
  request.post('/customer-api/customer/file/page', params)

export const download = id =>
  request.get(
    `/customer-api/customer/file/download/${id}`,
    {},
    { responseType: 'blob' },
  )
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
export const getUpload = username =>
  request.get(`/masterdata-api/user/active/query/${username}`)

export const downloadTemplate = type =>
  request.get(
    `/customer-api/customer/file/template/download/${type}`,
    {},
    { responseType: 'blob' },
  )
